import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ITradeHeader } from '../../../interfaces/trades/trade-header.model';
import { ITradeProduct } from '../../../interfaces/trades/trade-product.model';
import { IUpdateTradeLines } from '../../../interfaces/trades/update-trade-lines.model';
import { ISelectList } from '../../models/select-list.model';
import { ApiService } from '../api/api.service';
import { SeasonService } from '../season/season.service';
import { UserService } from '../user/user.service';
import { TradesService } from './trades.service';

@Injectable()
export class TradeProductsService {
  constructor(
    private tradesService: TradesService,
    private apiService: ApiService,
    private seasonService: SeasonService,
    private userService: UserService
  ) {}

  getProducts(
    header: ITradeHeader,
    filterText?: string,
    productTypeIds?: number[],
    showAll = false
  ): Promise<Array<ITradeProduct>> {
    const seasonId = this.getSeasonIdForTradeStockPeriod(header);
    let url = `v1/stocktrades/${header.businessId}/products?seasonid=${seasonId}`;

    if (filterText) {
      url += `&filtertext=${filterText}`;
    }

    if (productTypeIds && productTypeIds.length) {
      url += `&productTypeIds=${productTypeIds.join('&productTypeIds=')}`;
    }

    if (showAll != null) {
      url += `&showAll=${showAll}`;
    }

    return this.apiService.get(url);
  }

  saveTradeProducts(
    header: ITradeHeader,
    products: Array<ITradeProduct>,
    isPack: boolean
  ): Promise<any> {
    const currentStockPeriod = _.find(
      this.tradesService.stockPeriodList,
      (stockPeriod: ISelectList) => {
        return (
          stockPeriod.value === this.seasonService.displaySeason.toString()
        );
      }
    );
    if (header.stockPeriodId === 0 && currentStockPeriod) {
      header.stockPeriodId = currentStockPeriod.id;
    }
    const updateTradeLines: IUpdateTradeLines = {
      tradeLines: products,
      transactionHeaderId: header.id,
      tradingTypeId: header.tradingTypeId,
      stockPeriodId: header.stockPeriodId,
      isPack: isPack,
      businessId: header.businessId
    };
    return this.apiService
      .put(
        `v1/stocktrades/${updateTradeLines.businessId}/lines`,
        updateTradeLines
      )
      .then((response: Array<ITradeProduct>) => response);
  }

  private getSeasonIdForTradeStockPeriod(header: ITradeHeader): number {
    const selectedStockPeriodYear = parseInt(header.stockPeriodName, 10);
    const season = this.seasonService.seasons.find(
      x =>
        x.organisationId === this.userService.user.organisationId &&
        x.year === selectedStockPeriodYear
    );
    return season.id;
  }

  getProduct(id: number, header: ITradeHeader): Promise<ITradeProduct> {
    const seasonId = this.getSeasonIdForTradeStockPeriod(header);
    return this.apiService
      .get(
        `v1/stocktrades/${header.businessId}/product?productId=${id}&seasonid=${seasonId}`
      )
      .then((response: ITradeProduct) => {
        return response;
      });
  }
}
